import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Check } from "lucide-react";

export default function SubscribeForm({ variant = "card" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email, name: name || null });
      toast.success("you're on the list ♡");
      setDone(true);
    } catch (err) {
      toast.error("could not subscribe");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="bg-coal border border-hotpink/40 p-5 md:p-6 flex items-center gap-3" data-testid="subscribe-thanks">
        <Check className="text-hotpink" size={22}/>
        <div>
          <p className="font-outfit font-bold text-white">You're in.</p>
          <p className="scribble text-hotpink text-lg">we'll ping you the second a new episode drops.</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={"bg-coal border border-hotpink/40 p-5 md:p-6 " + (variant === "card" ? "" : "")} data-testid="subscribe-form">
      <div className="flex items-center gap-2 mb-3">
        <Mail size={20} className="text-hotpink" />
        <h3 className="font-outfit font-bold text-white text-lg">New episode alerts</h3>
      </div>
      <p className="scribble text-hotpink text-lg mb-4 rotate-[-1deg] inline-block">never miss a disaster</p>
      <div className="flex flex-col md:flex-row gap-2">
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="first name (optional)" className="md:w-40 bg-ink border border-white/15 px-3 py-2 text-white font-outfit text-sm focus:border-hotpink focus:outline-none" data-testid="subscribe-name" />
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@dating.disaster" className="flex-1 bg-ink border border-white/15 px-3 py-2 text-white font-outfit text-sm focus:border-hotpink focus:outline-none" data-testid="subscribe-email" />
        <button type="submit" disabled={busy || !email} className="bg-hotpink hover:bg-hotpink_dark text-white font-outfit font-extrabold uppercase tracking-widest text-xs px-5 py-2 shadow-[3px_3px_0px_#FFFFFF] hover:shadow-[5px_5px_0px_#FFFFFF] transition-all disabled:opacity-60" data-testid="subscribe-submit">
          {busy ? "..." : "alert me"}
        </button>
      </div>
      <p className="text-[10px] text-white/40 uppercase tracking-widest font-outfit mt-2">no spam · unsubscribe anytime</p>
    </form>
  );
}
